export const ARTICLE_FIGURES = {
    "solve-what-it-is": [
        {
            id: "solve-five-phases",
            afterHeading: "Start with something observable",
        },
    ],
    "vsm-see-the-whole-flow": [
        {
            id: "vsm-work-and-waiting",
            afterHeading: "Follow one customer need",
        },
    ],
    "vsm-flow-terms": [
        {
            id: "vsm-work-and-waiting",
            afterHeading: "Begin with definitions and units",
        },
    ],
    "platform-open-tabs-and-find-work": [
        {
            id: "platform-launcher",
            afterHeading: "Open a module",
        },
    ],
    "platform-set-account-and-launcher-preferences": [
        {
            id: "platform-preferences",
            afterHeading: "Make the screen comfortable to read",
        },
    ],
    "player-ai-participant-and-facilitator-guide": [
        {
            id: "player-ai-preferences",
            afterHeading: "Set your personal defaults",
        },
    ],
    "solve-create": [
        {
            id: "solve-create",
            afterHeading: "Create a useful starting point",
        },
    ],
    "solve-flexible-widgets": [
        {
            id: "solve-widget-picker",
            afterHeading: "Add a widget for a question",
        },
    ],
    "solve-specify-widgets": [
        {
            id: "solve-specify",
            afterHeading: "Problem Statement and Tags",
        },
    ],
    "solve-people-settings": [
        {
            id: "solve-people",
            afterHeading: "Access belongs to this SOLVE",
        },
    ],
    "vsm-current-state-build-guide": [
        {
            id: "vsm-current-map",
            afterHeading: "Open the right map",
        },
        {
            id: "vsm-process-data",
            afterHeading: "Enter evidence in data boxes",
        },
    ],
    "vsm-read-vsm-arrows": [
        {
            id: "vsm-palette",
            afterHeading: "At a glance",
        },
    ],
    "vsm-preparation-in-the-software": [
        {
            id: "vsm-sipoc",
            afterHeading: "Open SIPOC next",
        },
    ],
    "vsm-implementation-and-control": [
        {
            id: "vsm-kaizen-health",
            afterHeading: "Sequence changes as learning",
        },
    ],
    "hoshin-create-plan-and-cascade": [
        {
            id: "hoshin-create",
            afterHeading: "Start in the library",
        },
    ],
    "hoshin-ideate-present-and-group": [
        {
            id: "hoshin-ideate",
            afterHeading: "Ideate privately, then submit",
        },
    ],
    "hoshin-build-x-matrix-and-add-tti": [
        {
            id: "hoshin-x-matrix",
            afterHeading: "Build the logic first",
        },
    ],
    "hoshin-track-targets-and-linked-work": [
        {
            id: "hoshin-monitor",
            afterHeading: "Start with monitoring",
        },
    ],
    "lama-complete-your-assessment": [
        {
            id: "lama-assessment",
            afterHeading: "Answer from the stated scope",
        },
    ],
    "admin-add-people": [
        {
            id: "admin-add-people",
            afterHeading: "Add from Microsoft Entra",
        },
    ],
    "admin-identity-status": [
        {
            id: "admin-identity",
            afterHeading: "Start with the Overview tab",
        },
    ],
    "admin-scim-provisioning": [
        {
            id: "admin-provisioning",
            afterHeading: "Generate a client",
        },
    ],
    "admin-organization-profile": [
        {
            id: "admin-organization",
            afterHeading: "Update the profile",
        },
    ],
    "admin-module-availability": [
        {
            id: "admin-modules",
            afterHeading: "Turn an app on or off",
        },
    ],
    "admin-mail-server": [
        {
            id: "admin-mail-server",
            afterHeading: "Add a mail server",
        },
    ],
    "admin-notification-templates": [
        {
            id: "admin-templates",
            afterHeading: "Review message templates",
        },
    ],
    "admin-ai-connections": [
        {
            id: "admin-ai-connection",
            afterHeading: "Create a connection",
        },
    ],
    "admin-ai-profiles-defaults": [
        {
            id: "admin-ai-defaults",
            afterHeading: "Set app defaults",
        },
    ],
    "admin-integration-setup": [
        {
            id: "admin-integration",
            afterHeading: "Add from the deployment's catalogue",
        },
    ],
    "admin-adoption-tours": [
        {
            id: "admin-adoption-tours",
            afterHeading: "Offer onboarding tours again",
        },
    ],
    "admin-audit-history": [
        {
            id: "admin-audit",
            afterHeading: "Apply filters",
        },
    ],
};
//# sourceMappingURL=article-figures.js.map